import dayjs from "dayjs";

const formatDate = (dateString) => {
  // From 2025-10-01T21:27:14.341732Z to 01/10/2025
  if (!dateString) return "";
  return dayjs(dateString).format("DD/MM/YYYY");
};

const formatDateTime = (dateString) => {
  if (!dateString) return "";
  return dayjs(dateString).format("DD/MM/YYYY HH:mm");
};

export { formatDate, formatDateTime };
